module.exports = __webpack_public_path__ + "static/Convenient-c668f34ffad52985bf4bc5b7dd4e4b8e.png";